import MessageIcon from './MessageIcon'

export default MessageIcon
